import firebase from 'firebase/app';



export const scrollTo = (value) => {
  firebase.analytics().logEvent('scrolled_to', {
    value
  });
};
export const clickedLink = (value) => {
  firebase.analytics().logEvent('click_link', {
    value
  });
};
export const modalOpen = (value) => {
  firebase.analytics().logEvent('modal_open', {
    value
  });
};
export const darkModeChange = (value) => {
  firebase.analytics().logEvent('dark_mode', {
    value
  });
};
export const langChange = (value) => {
  firebase.analytics().logEvent('language', {
    value
  });
};
export const projectCategory = (value) => {
  firebase.analytics().logEvent('project-category', {
    value
  });
};

export const deviceSize = (value) => {
  const isMobile = window.innerWidth < 700 ? '<700-mobile' : '>700-desktop'; 
  firebase.analytics().logEvent('device_size', {
    value: isMobile
  });
}
